import React, {useEffect, useState} from "react";
import { Container, Grid, makeStyles, Paper, Typography} from "@material-ui/core";
import {useParams} from 'react-router-dom'
import {connect} from "react-redux";
import {getInvoiceDetail, savePickupDetails} from "../../redux/invoice-detail/InvoiceDetailServerActions";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceDetailLines from "./InvoiceDetailLines";
import CommentDialog from "./CommentDialog";
import {
    addLineComment,
    addLineImage, closePickupSaveNotification, handleNotificationClose, handlePickupInfoFormValueChange,
    removeLineImage, showNotification, updateAllLineStatus,
    updatePickupStatus
} from "../../redux/invoice-detail/InvoiceDetailViewActions";
import CameraDialog from "./CameraDialog";
import PickupInfoForm from "./PickupInfoForm";
import Notification from "../../components/Notification";
import Controls from "../../components/controls/Controls";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {NOTIFICATION_TIME} from "../../helpers/NotificationHelper";
import PickupSaveNotification from "./PickupSaveNotification";

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: "1rem",
        paddingBottom: "1rem"
    },
    alreadyPickedContainer: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: "flex"
    },
    alreadyPickedText: {
        display: 'inline',
        marginLeft: theme.spacing(1)
    },
    pickedIcon: {
        color: 'green'
    },
    invoiceHeader: {
        marginBottom: theme.spacing(2)
    }, backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))

function ViewInvoice(props) {
    const {
        savePickupDetail,
        getInvoiceDetail,
        addLineComment,
        addLineImage,
        removeLineImage,
        updatePickupStatus,
        updateAllLineStatus,
        invoiceDetail,
        closeNotification,
        openNotification,
        handlePickupInfoFormValueChange,
        closePickupSaveNotification
    } = props;
    let {invoiceNumber, source} = useParams();
    const [editRecordId, setEditRecordId] = useState('');
    const [openCommentDialog, setOpenCommentDialog] = useState(false);
    const [comment, setComment] = useState('');
    const [openCameraDialog, setOpenCameraDialog] = useState(false);
    const [lineImage, setLineImage] = useState('');

    const handleSavePickupDetail = (e, formValues) => {
        e.preventDefault();
        const pickupLines = invoiceDetail.lineActions.filter(lineAction => lineAction.pickup);
        if (!pickupLines || pickupLines.length === 0) {
            openNotification('error', 'Please select at least a line to pickup');
            return;
        }
        savePickupDetail(invoiceDetail.lineActions, {...formValues, invoiceNumber, source}, source, invoiceNumber);
    }

    useEffect(() => {
        getInvoiceDetail(source, invoiceNumber)
    }, [getInvoiceDetail, invoiceNumber, source])

    const handleNotificationClose = () => {
        closeNotification();
    }

    const handleHeaderCheckBoxClick = (e) => {
        let checked = e.target.checked;
        updateAllLineStatus(checked);
        // setHeaderChecked(checked);
    }

    const handlePickupLineClick = (e, lineId) => {
        let checked = e.target.checked;
        updatePickupStatus(lineId, checked);

    }

    const handleCommentBtnClick = (e, id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) {
            return;
        }
        setEditRecordId(detailLineAction.id);
        setOpenCommentDialog(true);
        setComment(detailLineAction.comment);
    }

    const handleCommentDialogClose = () => {
        setOpenCommentDialog(false);
    }

    const handleCommentDialogSave = (id, comment) => {
        handleCommentDialogClose();
        addLineComment(id, comment)
    }

    const handleCommentInputChange = (e) => {
        setComment(e.target.value);
    }

    const getLineComment = (id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) return;
        return detailLineAction.comment;
    }
    const isPickupLineSelected = (id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) {
            return false;
        }
        return detailLineAction.pickup;
    }
    const showActionButtons = (id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) {
            return false;
        }
        return detailLineAction.showActionButtons;
    }

    const checkHeaderCheckedStatus = () => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.showActionButtons && !line.pickup);
        return !detailLineAction;
    }


    // Start camera dialog methods
    const handleCameraBtnClick = (e, id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) {
            return;
        }
        setEditRecordId(detailLineAction.id);
        setOpenCameraDialog(true);
        setLineImage(detailLineAction.supportingImage);
    }
    const handleCameraDialogClose = () => {
        setOpenCameraDialog(false);
    }
    const handleLineImageCapture = (id, image) => {
        addLineImage(id, image);
        setLineImage(image)
    }

    const getLineSupportingImage = (id) => {
        const detailLineAction = invoiceDetail.lineActions.find(line => line.id === id);
        if (!detailLineAction) {
            return '';
        }
        return detailLineAction.supportingImage;
    }
    // End camera dialog methods

    const handleFormValueChange = (name, value) => {
        handlePickupInfoFormValueChange(name, value);
    }

    const removeSupportingImage = (e, id) => {
        removeLineImage(id)
    }
    const showDetailLines = () => {
        return <InvoiceDetailLines
            detailLines={invoiceDetail.details}
            isPickupLineSelected={isPickupLineSelected}
            showActionButtons={showActionButtons}
            handlePickupLineClick={handlePickupLineClick}
            handleCommentBtnClick={handleCommentBtnClick}
            getLineComment={getLineComment}
            getLineSupportingImage={getLineSupportingImage}
            handleCameraBtnClick={handleCameraBtnClick}
            removeSupportingImage={removeSupportingImage}
            handleHeaderCheckBoxClick={handleHeaderCheckBoxClick}
            displayHeaderCheckbox={invoiceDetail.invoiceHeader.hasActionableLines}
            headerCheckedStatus={checkHeaderCheckedStatus}
            loading={invoiceDetail.isLoading}
            displayItemCodeField={invoiceDetail.setting.displayItemCodeField}
            displayPriceField={invoiceDetail.setting.displayPriceField}
        />;
    }

    const classes = useStyles();

    function getMainView() {
        if (invoiceDetail && invoiceDetail.invoiceHeader) {
            return (
                <Grid container className={classes.root}>
                    <Grid item xs={12} md={12}>
                        {
                            !invoiceDetail.invoiceHeader.hasActionableLines &&
                            <div>
                                <Paper className={classes.alreadyPickedContainer}>
                                    <CheckCircleIcon className={classes.pickedIcon}/>
                                    <Typography className={classes.alreadyPickedText}>This invoice has already been
                                        picked</Typography>
                                </Paper>
                            </div>}
                        <div className={classes.invoiceHeader}>
                            {<InvoiceHeader
                                loading={invoiceDetail.isLoading}
                                header={invoiceDetail.invoiceHeader}
                                displayPriceField={invoiceDetail.setting.displayPriceField}/>}
                        </div>
                        <div>
                            {showDetailLines()}
                        </div>
                    </Grid>
                    {
                        invoiceDetail && invoiceDetail.invoiceHeader.hasActionableLines &&
                        <Grid item xs={12} md={12}>
                            <PickupInfoForm
                                handlePickupDetailSave={handleSavePickupDetail}
                                saving={invoiceDetail.saving}
                                roles={invoiceDetail.roles}
                                formValues={invoiceDetail.formValues}
                                handleFormValueChange={handleFormValueChange}
                            />
                        </Grid>
                    }
                </Grid>
            );
        }
        return null;

    }

    return (
        <React.Fragment>
            {invoiceDetail.isLoading && <Controls.ProgressBar/>}
            <Container maxWidth='xl'>
                <div>
                    {getMainView()}
                    <CommentDialog
                        recordNumber={editRecordId}
                        open={openCommentDialog}
                        handleCommentInputChange={handleCommentInputChange}
                        comment={comment}
                        handleClose={handleCommentDialogClose}
                        handleSave={handleCommentDialogSave}
                    />
                    <CameraDialog
                        recordNumber={editRecordId}
                        open={openCameraDialog}
                        lineImage={lineImage}
                        handleClose={handleCameraDialogClose}
                        handleLineImageCapture={handleLineImageCapture}/>

                    <Notification
                        open={invoiceDetail.notification.show}
                        type={invoiceDetail.notification.type}
                        message={invoiceDetail.notification.message}
                        handleClose={handleNotificationClose}
                        hideDuration={NOTIFICATION_TIME}
                        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    />

                    <PickupSaveNotification
                        showPickupSaveNotification={invoiceDetail.pickupSaveNotification.show}
                        closePickupSaveNotification={closePickupSaveNotification}
                        success={invoiceDetail.pickupSaveNotification.success}
                        message={invoiceDetail.pickupSaveNotification.message}
                        url={invoiceDetail.pickupSaveNotification.url}/>
                </div>

            </Container>

        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        invoiceDetail: state.invoiceDetail
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getInvoiceDetail: (source, invoiceNumber) => getInvoiceDetail(source, invoiceNumber),
        addLineComment: (id, comment) => addLineComment(id, comment),
        addLineImage: (id, image) => addLineImage(id, image),
        removeLineImage: (id) => removeLineImage(id),
        updatePickupStatus: (id, status) => updatePickupStatus(id, status),
        updateAllLineStatus: (checkedStatus) => updateAllLineStatus(checkedStatus),
        savePickupDetail: (pickupLines, pickupInfo, source, invoiceNumber) => savePickupDetails(pickupLines, pickupInfo, source, invoiceNumber),
        closeNotification: () => handleNotificationClose(),
        openNotification: (type, message) => showNotification(type, message),
        handlePickupInfoFormValueChange: (name, value) => handlePickupInfoFormValueChange(name, value),
        closePickupSaveNotification: () => closePickupSaveNotification()
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(ViewInvoice);
